module.exports = __webpack_public_path__ + "img/default.8b7ea4e7.jpg";